import { create } from "lodash";
import _BaseAPIService from "../_BaseAPIService";
import { update } from "lodash";

const apiService = _BaseAPIService.instance;

const TimelineService = {
    getdata: async () => {
        const response = await apiService.get("/organizationtimeline");
        return response.data;
    },
    getDetails : async (id) => {
        const response = await apiService.get(`/organizationtimeline/${id}`)
        return response.data;
    },
    create: async (payload) => {
        const response = await apiService.post("/organizationtimeline", payload);
        return response.data;
    },
    update: async (id, updatedData) => {
        try {
            const response = await apiService.put(`/organizationtimeline/${id}`, updatedData);
            return response.data;
        } catch (error) {
            console.error("Error updating timeline:", error);
            throw error;
        }
    },
    delete: async (id) => {
        const response = await apiService.delete(`/organizationtimeline/${id}`);
        return response.data;
    },
}

export default TimelineService;